// src/configs/tailwind.config.ts
var tailwind_config_default = {
  theme: {
    aspectRatio: {
      square: "1 / 1",
      "2/1": "2 / 1",
      "3/2": "3 / 2",
      "4/3": "4 / 3",
      video: "16 / 9",
      "21/9": "21 / 9"
    },
    colors: {
      inherit: "inherit",
      blue: "var(--color-blue)",
      "royal-blue-100": "var(--color-royal-blue-100)",
      "royal-blue-80": "var(--color-royal-blue-80)",
      "royal-blue-70": "var(--color-royal-blue-70)",
      "royal-blue-60": "var(--color-royal-blue-60)",
      "royal-blue-40": "var(--color-royal-blue-40)",
      "royal-blue-30": "var(--color-royal-blue-30)",
      "royal-blue-20": "var(--color-royal-blue-20)",
      "royal-blue-10": "var(--color-royal-blue-10)",
      "royal-blue-light": "var(--color-royal-blue-light)",
      "white-100": "var(--color-white-100)",
      "white-80": "var(--color-white-80)",
      "white-70": "var(--color-white-70)",
      "white-40": "var(--color-white-40)",
      "white-20": "var(--color-white-20)",
      "white-10": "var(--color-white-10)",
      stone: "var(--color-stone)",
      "stone-tag": "var(--color-stone-tag)",
      "stone-light": "var(--color-stone-light)",
      "stone-extralight": "var(--color-stone-extralight)",
      "smoke-light": "var(--color-smoke-light)",
      "smoke-10": "var(--color-smoke-10)",
      error: "var(--color-error)",
      intBlue: "var(--color-int-blue)",
      intOrange: "var(--color-int-orange)",
      intPurple: "var(--color-int-purple)",
      intGreen: "var(--color-int-green)"
    },
    screens: {
      sm: "600px",
      md: "960px",
      lg: "1281px",
      xl: "1600px"
    },
    spacing: {
      none: "var(--spacing-none)",
      base: "var(--spacing-base)",
      "3xs": "var(--spacing-3xs)",
      "2xs": "var(--spacing-2xs)",
      xs: "var(--spacing-xs)",
      s: "var(--spacing-s)",
      sm: "var(--spacing-sm)",
      m: "var(--spacing-m)",
      lm: "var(--spacing-lm)",
      l: "var(--spacing-l)",
      xl: "var(--spacing-xl)",
      "2xl": "var(--spacing-2xl)",
      "3xl": "var(--spacing-3xl)",
      "4xl": "var(--spacing-4xl)",
      "component-small": "var(--spacing-component-small)",
      "component-medium": "var(--spacing-component-medium)",
      "component-big": "var(--spacing-component-big)",
      row: "var(--spacing-row)",
      "row-screen": "var(--spacing-row-screen)",
      "row-padding": "var(--spacing-row-padding)",
      grid: "var(--spacing-grid)"
    },
    fontSize: {
      "h1-300": [
        "var(--font-size-h1-300)",
        {
          lineHeight: "var(--line-height-h1-300)",
          fontWeight: "300"
        }
      ],
      "h1-overview-200": [
        "var(--font-size-h1-overview-200)",
        {
          lineHeight: "var(--line-height-h1-overview-200)",
          letterSpacing: "var(--letter-spacing-h1-overview-200)",
          fontWeight: "200",
          // this property will not show up in the editor tooltip of h1-overview-200
          textTransform: "uppercase"
        }
      ],
      "h2-200": [
        "var(--font-size-h2-200)",
        {
          lineHeight: "var(--line-height-h2-200)",
          fontWeight: "200"
        }
      ],
      "h2-300-text-on-image": [
        "var(--font-size-h2-300-text-on-image)",
        {
          lineHeight: "var(--line-height-h2-300-text-on-image)",
          fontWeight: "300"
        }
      ],
      "h2-section-title-300": [
        "var(--font-size-h2-section-title-300)",
        {
          lineHeight: "var(--line-height-h2-section-title-300)",
          letterSpacing: "var(--letter-spacing-h2-section-title-300)",
          fontWeight: "300",
          // this property will not show up in the editor tooltip of h2-section-title-300
          textTransform: "uppercase"
        }
      ],
      "h2-subtitle-300": [
        "var(--font-size-h2-subtitle-300)",
        {
          lineHeight: "var(--line-height-h2-subtitle-300)",
          fontWeight: "300"
        }
      ],
      "h3-300": [
        "var(--font-size-h3-300)",
        {
          lineHeight: "var(--line-height-h3-300)",
          fontWeight: "300"
        }
      ],
      "h4-700": [
        "var(--font-size-h4-700)",
        {
          lineHeight: "var(--line-height-h4-700)",
          fontWeight: "700"
        }
      ],
      "h5-700": [
        "var(--font-size-h5-700)",
        {
          lineHeight: "var(--line-height-h5-700)",
          fontWeight: "700"
        }
      ],
      "p-300": [
        "var(--font-size-p-300)",
        {
          lineHeight: "var(--line-height-p-300)",
          fontWeight: "300"
        }
      ],
      "p-big-300": [
        "var(--font-size-p-big-300)",
        {
          lineHeight: "var(--line-height-p-big-300)",
          fontWeight: "300"
        }
      ],
      "p-highlight-700": [
        "var(--font-size-p-highlight-700)",
        {
          lineHeight: "var(--line-height-p-highlight-700)",
          fontWeight: "700"
        }
      ],
      "p-link": [
        "var(--font-size-p-link)",
        {
          lineHeight: "var(--line-height-p-link)",
          fontWeight: "300"
        }
      ],
      "p-mini-highlight-700": [
        "0.8125rem",
        {
          lineHeight: "1.25rem",
          fontWeight: "700"
        }
      ],
      "p-mini": [
        "0.8125rem",
        {
          lineHeight: "1.25rem",
          fontWeight: "300"
        }
      ],
      "p-small-highlight": [
        "1rem",
        {
          lineHeight: "1.625rem",
          fontWeight: "700"
        }
      ],
      "p-small": [
        "1rem",
        {
          lineHeight: "1.625rem",
          fontWeight: "300"
        }
      ],
      "upper-case-400": [
        "0.6875rem",
        {
          lineHeight: "0.75rem",
          letterSpacing: "0.0625rem",
          fontWeight: "400",
          // this property will not show up in the editor tooltip of upper-case-400
          textTransform: "uppercase"
        }
      ],
      "upper-case-700": [
        "0.6875rem",
        {
          lineHeight: "1rem",
          letterSpacing: "0.0625rem",
          fontWeight: "700",
          // this property will not show up in the editor tooltip of upper-case-700
          textTransform: "uppercase"
        }
      ],
      "upper-case-900": [
        "0.6875rem",
        {
          lineHeight: "1rem",
          letterSpacing: "0.125rem",
          fontWeight: "900",
          // this property will not show up in the editor tooltip of upper-case-900
          textTransform: "uppercase"
        }
      ]
    },
    extend: {
      backgroundImage: {
        resizer: `url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.33798 0.221924L0.718262 7.29299L1.38023 8.0001L7.99996 0.929031L7.33798 0.221924ZM7.11087 4.46457L4.46299 7.29299L5.12496 8.0001L7.77285 5.17167L7.11087 4.46457Z' fill='%23141E55'/%3E%3C/svg%3E%0A")`
      }
    }
  }
};

export {
  tailwind_config_default
};
